import type { ReactNode } from 'react';
import { Logo } from '@/components/brand/logo';
import { Card } from '@/components/ui/card';

/** Moldura das telas sem sessão (login, 2FA, senha, convite). */
export function AuthCard({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: ReactNode;
}) {
  return (
    <main className="flex min-h-svh flex-col items-center justify-center gap-8 p-6">
      <Logo variant="vertical" className="h-28" />
      <Card className="w-full max-w-sm p-6">
        <h1 className="text-xl font-semibold">{title}</h1>
        {description ? <p className="mt-1 text-sm text-muted-foreground">{description}</p> : null}
        <div className="mt-6">{children}</div>
      </Card>
    </main>
  );
}
